import React from 'react';
import StyledField from "../../../components/StyledField/StyledField";
import FileUpload from "../../../components/FileUpload/FileUpload";
import Checkbox from "../../../components/Checkbox/Checkbox";
import ColorSelect from "../../../components/ColorSelect/ColorSelect";
import { Field } from "formik";
import FormPosition from '../../../components/FormPosition/FormPosition';

const Overview = ({ values, firebase, activeTab, errors, id, ...props }) => (
    <section className={ activeTab === 'overview' ? 'tab-content is-enabled' : 'tab-content' }>
  <div className="grid">
    <div className="grid-item">
      <div className="field-group">
        <Field component={ StyledField }
               hint="The title will appear in as the thumbnail for the project on the Explore Our Work section."
               label="Project name"
               name="name"
               { ...props }
        />
        <Checkbox label="Show on site" name="enabled" />
      </div>
    </div>
    <div className="grid-item">
      <div className="field-group">
        <Field component={ StyledField }
               hint="A directory name to store photos for project."
               label="Directory" name="directory"
               readOnly={ values['directory'] && id !== 0 }
               { ...props }
        />
      </div>
    </div>
  </div>

  <div className="grid">
    <div className="grid-item">
      <FileUpload firebase={ firebase }
                  directory={ values.directory }
                  name="thumbnailPath.url"
                  label="Select a thumbnail Image"
                  hint="File should be 800 x 500 pixels."
      />
    </div>
    <div className="grid-item">
      <img src={ values.thumbnailPath.url } style={ { width: '200px', height: 'auto' }} alt="" />
    </div>
  </div>

  <div className="field-group">
    <div className="grid">
      <div className="grid-item">
        <h3>Overview (appears on slide 2)</h3>
        <div className="field-group">
          <Field label="Title"
                 hint="This title will appear on the second slide. Leave blank to use the Project title above."
                 component={ StyledField }
                 name="overview.title"
          />
        </div>
        <div className="field-group">
          <label className="label-inline">Copy</label>
          <Field component="textarea" name="overview.copy" />
          <Checkbox label="Enabled" name="overview.enabled" hint="(Uncheck to hide this copy from the first slide)" />
        </div>
        <Field component={ FormPosition } values={ values.overview } label="Overview positioning" name="overview.position"/>
        <div className="field-group">
          <ColorSelect name="overview.color" label="Text Color" />
        </div>
      </div>

      <div className="grid-item">
        <h3>Quotation (appears on slide 1)</h3>
        <div className="field-group">
          <label className="label-inline">Copy</label>
          <Field component="textarea" name="quote.copy" />
        </div>
        <div className="field-group">
          <Field label="Citation" component={ StyledField } name="quote.citation" />
        </div>
        <div>
          <Field component={ FormPosition } values={ values.quote } label="Quote positioning" name="quote.position"/>
        </div>
        <div className="field-group">
          <ColorSelect name="quote.color" label="Text Color" />
        </div>
      </div>
    </div>
  </div>
</section>);

export default Overview;



// WEBPACK FOOTER //
// ./src/containers/add/Overview/index.js